import * as React from 'react';
import $ from "jquery";
import Common from './common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { ComunidadAutonoma } from '../ComunidadesAutonomas/ComunidadAutonoma';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';

export interface IErrorDialogProps {
    open: boolean;
    onClose: any;
}

export interface IErrorDialogState {
    open: boolean;
}

export default class ErrorDialog extends React.Component<IErrorDialogProps, IErrorDialogState> {
    
    public constructor(props: IErrorDialogProps) {
        super(props);

        this.state = {
            open: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IErrorDialogProps>, nextContext: any): void {
        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth>
                <DialogTitle>
                    Error
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid item xs={1}>
                            <ErrorOutlinedIcon color='error' style={{fontSize: '42px'}}/>
                        </Grid>
                        <Grid item xs={11}>
                            <Typography variant='body2'>
                                Ocurrió un error al guardar los datos. Pruebe de nuevo y si el problema persiste póngase en contacto con el administrador del sistema.
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.Close.bind(this)}>Ok</Button>
                </DialogActions>
            </Dialog>
        )
    }

    private Close() {
        this.setState(
            {
                open: false
            }
        );

        if(this.props.onClose != null) {
            console.log('LLamando a onClose');
            this.props.onClose();
        }
    }
}